// extracted by mini-css-extract-plugin
export default {"title":"CustomerReviews_title__MMXQS","container":"CustomerReviews_container__V9Eei"};